import RubleIcon from '@root/public/images/requests/subtract.svg'

import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'

type Props = {
  serviceName: string
  typeAlias: RequestTypeAlias
  isPayable?: boolean
}

const ContentBlockServiceName = ({
  serviceName,
  typeAlias,
  isPayable
}: Props) => {
  const label =
    typeAlias === RequestTypeAlias.CommonRequest
      ? 'Название услуги'
      : 'Название пропуска'

  if (label && serviceName) {
    return (
      <div className="mb-24 sm:order-1">
        <p className="mb-4 font-bold text-grey-90 text-16">{label}</p>
        <div className="flex items-center gap-8 font-pro text-16">
          {serviceName}
          {isPayable && (
            <RubleIcon
              alt="ruble-icon"
              data-testid="request-service-ruble-icon-id"
            />
          )}
        </div>
      </div>
    )
  }
}

export default ContentBlockServiceName
